import { IAthlete } from '../data/types';

/**
 * @description remove PII from an athlete
 * @param athlete
 * @returns
 */
export const deidentifyAthlete = (athlete: IAthlete): IAthlete => {
  return {
    ...athlete,
    name: athlete.id,
    position: '--',
  };
};
